<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold modal-title">Skicka meddelande</p>
    </div>
    <div class="modal-content">
      <p class="all-caps mb-15">Skicka genom</p>
      <div class="flex mb-30">
        <div class="mr-50"><label><input type="radio" class="mr-5" value="sms" v-model="deliveryWay">SMS</label></div>
        <div><label><input type="radio" class="mr-5" value="email" v-model="deliveryWay">E-post</label></div>
      </div>

      <p class="all-caps mt-20 mb-15">till</p>
      <div class="mb-20">
        <ul>
          <li class="grid2col grid2col--icon-row mb-15" v-for="(messageReceiver, index) in messageReceivers" v-bind:key="index">
            <div v-bind:class="{ disabled: phoneMailVerify(messageReceiver) }">
              {{ messageReceiver.firstname || messageReceiver.name }} {{ messageReceiver.lastname }}
              <p class="fs-12 opaque-60">{{ deliveryWay === "sms" ? messageReceiver.cellphone : messageReceiver.email }}</p>
            </div>
            <div class="flex align-middle pr-5 justify-end"><img @click="remove(index)" alt="icon" src="@/assets/icons/remove.svg"></div>
          </li>
        </ul>
      </div>

      <p class="all-caps mt-20 mb-5">meddelandemall</p>
      <select v-model="chosenMessagingTemplate" v-if="templates" @change="changeTemplate">
        <option v-for="(template, index) in templates" v-bind:key="index" v-bind:value="template.id">{{ template.alias }}</option>
      </select>

      <div v-show="this.deliveryWay !== 'sms'">
        <p class="all-caps mt-20 mb-5">Ämne (för e-post)</p>
        <input type="text" class="width-100 p15" v-model="subject">
      </div>
      <p class="all-caps mt-20 mb-5">meddelande</p>
      <div class="mt-15 mb-15" v-if="deliveryWay === 'email'">
        <label class="switch mr-10">
          <input type="checkbox" class="mr-5" v-model="autoSignature">
          <div class="slider round"></div>
        </label>
        <span>Lägg till signatur automatiskt</span>
      </div>
      <textarea name="" id="" class="width-100 p15" rows="8" v-model="content"></textarea>
    </div>


    <div class="modal-buttons mt-10">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="send">
          skicka
        </button>
      </div>
    </div>
    <spinner v-show="loading"/>
  </div>
</template>

<script>
import spinner from '../../spinner';
import Bugsnag from '@bugsnag/js';

export default {
  name: 'sendSmsOrMail',
  data() {
    return {
      autoSignature: true,
      loading: false
    }
  },
  components: {
    spinner
  },
  computed: {
    templates() {
      // current users messaging templates from store
      return this.$store.state.currentUserMessagingTemplates;
    },
    messageReceivers(){
      return this.$store.state.sendSmsOrMailContactData.receivers;
    },
    subject: {
      get() {
        return this.$store.state.sendSmsOrMailContactData.subject;
      },
      set(value){
        this.$store.commit("STORE_SMS_MAIL_SUBJECT", value);
      }
    },
    content: {
      get() {
        return this.$store.state.sendSmsOrMailContactData.message;
      },
      set(value){
        this.$store.commit("STORE_SMS_MAIL_CONTENT", value);
      }
    },
    deliveryWay: {
      get() {
        return this.$store.state.sendSmsOrMailContactData.deliveryWay;
      },
      set(value){
        this.$store.commit("STORE_SMS_MAIL_DELIVERYWAY", value);
      }
    },
    chosenMessagingTemplate: {
      get() {
        return this.$store.state.sendSmsOrMailContactData.chosenMessagingTemplate;
      },
      set(value){
        this.$store.commit("STORE_SMS_MAIL_CHOSEN_MESSAGING_TEMPLATE", value);
      }
    },
    service: {
      get() {
        return this.$store.state.sendSmsOrMailWhichService;
      },
    }
  },
  created() {
  },
  methods: {
    resetContactData() {
      this.$store.commit("STORE_SMS_MAIL_SUBJECT", "");
      this.$store.commit("STORE_SMS_MAIL_CONTENT", "");
      this.$store.commit("STORE_SMS_MAIL_CHOSEN_MESSAGING_TEMPLATE", "");
      this.$store.commit("STORE_SMS_MAIL_RECIEVERS", []);
      this.$store.commit("STORE_SMS_MAIL_WHICH_SERVICE", null);
    },
    remove(index) {
      this.messageReceivers.splice(index, 1);
    },
    phoneMailVerify(person){
      // highlight if person will not recieve sms or mail
      return !person.cellphone && this.deliveryWay === "sms" || !person.email && this.deliveryWay === "email";
    },
    changeTemplate() {
      let template = this.$store.state.sendSmsOrMailContactData.chosenMessagingTemplate;

      this.$root.callFasAdApi("/internalapi/message-template/get-content/templateId/" + template + "/objectId/" + this.$route.params.id)
      .then((data) => {
        this.$store.commit("STORE_SMS_MAIL_SUBJECT", data.data.subject);
        this.$store.commit("STORE_SMS_MAIL_CONTENT", data.data.content);
      })
      .catch((error) => {
        Bugsnag.notify(error);
        Bugsnag.notify(template);
      });
    },
    abort() {
      this.$root.modalOpen = false;
    },
    sendMessage(message) {
      let endPoint = "send-mail";
      if (this.deliveryWay === "sms") {
        endPoint = "send-sms";
      }

      this.$root.callFasAdApi("/internalapi/send-message/" + endPoint, "POST", message)
      .then((data) => {
        if (data.status === 200) {
          this.$root.modalOpen = false;
          this.loading = false;
          setTimeout(() => {
            this.$root.handleResponseMessage(data, "Meddelande skickat!");
            // Reset previous messages
            this.resetContactData();
          }, 600);
        } else if (data.status === 400) {
          this.$root.modalOpen = false;
          setTimeout(() => {
            this.$root.handleResponseMessage(data, "Kunde inte skicka SMS");
            // Reset previous messages
            this.resetContactData();
          }, 600);
        }

      })
      .catch((error) => {
        Bugsnag.notify(error);
        Bugsnag.notify(message);
      });
    },
    send() {
      if (!this.messageReceivers.length) {
        Bugsnag.notify("No message recievers upon trying to send sms/mail from sendSmsOrMail. ObjectId: " + this.$route.params.id);
      }
      if (!this.deliveryWay.length) {
        Bugsnag.notify("No deliveryway upon trying to send sms/mail from sendSmsOrMail. ObjectId: " + this.$route.params.id);
        Bugsnag.notify(this.$store.state.sendSmsOrMailContactData);
      }
      this.loading = true;
      //window.helpers.modalOpen = false;
      let message = {
        message: this.content,
        objectId: this.$route.params.id,
        customers: [],
        categoryId : 1 // ref: SELECT * FROM mailcategory or smscategory;
      };

      // if sms, get customers phone numbers
      if (this.deliveryWay === "sms") {
        message.phoneNumbers = [];
        this.messageReceivers.forEach((customer) => {
          if (customer.cellphone) {
            if (this.service === 'showing') {
              if (this.$store.state.showing.currentListingWithActiveShowing.realtor) {
                if (customer.id && customer.id !== this.$store.state.showing.currentListingWithActiveShowing.realtor.id) {
                  message.customers.push(customer.id);
                }
              }
            } else {
              // We can't add realtors OR realtor assistant id into customers, need to first check if there is realtor because if removed
              // as receiver in bidsettings, it becomes null
              let realtorId, assistantId;
              if (this.$store.state.currentListingWithBiddingsBidReceivers.realtor) {
                realtorId = this.$store.state.currentListingWithBiddingsBidReceivers.realtor.id;
              }
              if (this.$store.state.currentListingWithBiddingsBidReceivers.assistant) {
                assistantId = this.$store.state.currentListingWithBiddingsBidReceivers.assistant.id;
              }
              if (customer.id !== realtorId && customer.id !== assistantId) {
                message.customers.push(customer.id);
              }
              message.phoneNumbers.push(customer.cellphone);
            }
          }
        });
      }

      // if mail, get customers email adresses and set subject
      if (this.deliveryWay === "email") {
        message.realtors = [];
        message.autoSignature = this.autoSignature ? 1 : 0;
        message.subject = this.subject;
        this.messageReceivers.forEach((customer) => {
          if (customer.email) {
            message.customers.push(customer.id);
          }
        });
        if (this.service === "showing"){
          message.realtors.push(this.$store.state.showing.currentListingWithActiveShowing.realtor.email);
        } else {
          message.realtors.push(this.$store.state.currentListingWithBiddingsBidReceivers.realtor.email);
        }
      }
      this.sendMessage(message);
    }
  }
}
</script>

<style>
.disabled {
  text-decoration: line-through;
  opacity: .5;
}
</style>
